<template>
  <div class="knowledgeBaseManagementList">
    <el-card>
      <!-- 添加按钮 -->
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_knowledgeBaseAdd')}}</el-button>
      <el-table :data="tableData" class="wid100" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- 多选框 -->
        <el-table-column type="selection" width="55" v-if="this.knowledgeBaseManagementCbx"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <!-- 物业/项目 -->
        <el-table-column prop="gardenId" :label="$t('lang.lbl_knowledgeBase_gardenId')">
          <template slot-scope="scope">
            <span v-if="scope.row.gardenId === 1" >{{$t('lang.lbl_propertyKnowledge')}}</span>
            <span v-if="scope.row.gardenId === 2">{{$t('lang.lbl_projectKnowledge')}}</span>
          </template>
        </el-table-column>
        <!-- 分类名称 -->
        <el-table-column prop="name" :label="$t('lang.lbl_knowledgeBase_name')" ></el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deletetable(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout=" sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <!-- 添加弹框 -->
    <el-dialog :title='title' :visible.sync="isPopupPage" :close-on-click-modal="false" center top="130px" width="600px" @closed="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_w8" :label-suffix="require('@/config/enum').c_colon">
          <!-- 物业分类/项目分类 -->
          <el-form-item :label="$t('lang.lbl_propertyCateORprojectCate')" prop="dia_gardenId">
            <el-select v-model="form.dia_gardenId">
              <el-option
              v-for="(item,index) in gardenIdList"
              :key="index"
              :label="item.name"
              :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>          
          <!-- 分类名称 -->
          <el-form-item :label="$t('lang.lbl_knowledgeBase_name')" prop="dia_name">
            <el-input v-model="form.dia_name" :placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_knowledgeBase_name')"></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
          <el-button type="primary" @click="save('form')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:knowledgeBaseManagementList
 *@Description:物业知识库分类管理
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-04-08
 */
export default {
  data() {
    return {
      isDisabled: true, // 按钮置灰
      saveData: '', // 存储json字符串
      editid: '', // 判断添加/修改
      title: '', // 弹框的标题
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      multipleSelection: [], // 多选框
      tableData: [], // 列表数组
      knowledgeBaseManagementCbx: require('@/config/enum').knowledgeBaseManagementCbx, // 是否隐藏复选框
      isPopupPage: false, // 弹框的显示控制
      gardenId: '', // 物业/项目
      gardenIdList: this.$i18n.t('lang.PROPERTYKNOWLEDGE.GENDER'), // 物业/项目分类列表
      name: '', // 分类名称
      form: {
        dia_gardenId: '', // 物业分类/项目分类
        dia_name: '', // 分类名称
      },
      rules: {
        dia_gardenId: [{ required: true, message: '', trigger: 'blur' }],
        dia_name: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lbl_knowledgeBase_name'), trigger: 'blur' }],
      },      
    }
  },
  created () {
    this.getTablelist()
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 物业知识库分类管理
    getTablelist() {
      let loading = this.$loading()
      this.$get(`/knowledgeTypePage?pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.clear()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    edit(row) {
      this.editid = row.id
      this.title = this.$i18n.t('lang.btn_knowledgeBaseedit')
      this.form.dia_gardenId = row.gardenId
      this.form.dia_name = row.name
      this.saveData = JSON.stringify(this.form)
      this.isPopupPage = true
    },
    add() {
      this.editid = ''
      this.form.dia_gardenId = 1
      this.form.dia_name = ''
      this.title = this.$i18n.t('lang.btn_knowledgeBaseAdd')
      this.isPopupPage = true
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
    },
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.$delete(`/knowledgeType/` + id).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message({
                type: 'success',
                message: this.$i18n.t('lang.lab_del_success')
              })
              this.commit()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      })
      .catch(() => {
        loading.close()
        this.$message({
          type: 'info',
          message: this.$i18n.t('lang.lab_del_can')
        })
      })
    },
    clear() {
      this.$refs.form.clearValidate()
      this.form.dia_gardenId = 1
      this.form.dia_name = ''
    },
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.editid === '') {
            let loading = this.$loading()
            let params = {
              gardenId: this.form.dia_gardenId,
              name: this.form.dia_name             
            }
            this.$post(`/knowledgeType`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let loading = this.$loading()
            let params = { 
              gardenId: this.form.dia_gardenId,
              name: this.form.dia_name             
            }
            this.$patch(`/knowledgeType/${this.editid}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        }
      })
    },
  }
}
</script>

<style lang="scss">
</style>
